<template>
  <div class="test-mode-toggle" :class="{ '-active': testMode }">
    <a href="#" @click.prevent="toggle()">
      {{ testMode ? "Viewing test data" : "View test data" }}
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {},

  props: {
    onChange: {
      type: Function,
      required: true
    }
  },

  computed: {
    ...mapState({
      testMode: (state) => state.conversations.testMode
    })
  },

  methods: {
    toggle() {
      this.$store.dispatch("toggleTestMode").then(this.onChange);
    }
  }
};
</script>
